(self["webpackChunk"] = self["webpackChunk"] || []).push([[900,662,169,393],{

/***/ 84560:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(56187);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(38690);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(89228);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(26031);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2663);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91270);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(13227);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(88646);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(95822);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(48949);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(11908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(86225);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(44567);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(3127);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(59139);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(54134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(14011);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(47134);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(11431);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(62659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(81414);
// EXTERNAL MODULE: ./snippets/figure-base/index.js
var figure_base = __webpack_require__(87205);
// EXTERNAL MODULE: ./snippets/visible-audience/index.js + 1 modules
var visible_audience = __webpack_require__(10434);
// EXTERNAL MODULE: ./snippets/icon-font/index.js
var icon_font = __webpack_require__(95974);
// EXTERNAL MODULE: ./snippets/product-label/create.js
var create = __webpack_require__(83050);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(84159);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(96626);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(81970);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(39574);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(43908);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(37666);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(33373);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(31955);
// EXTERNAL MODULE: ./utils/request/index.js + 4 modules
var request = __webpack_require__(19650);
;// CONCATENATED MODULE: ./api/member.js






function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

// 个人信息
var getMyProfile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(memberEmail, customerId) {
    var result, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return (0,request/* heteRequest */.xC)('/crm/front/shopify/member/personalCenter/myProfile', {
            data: {
              memberEmail: memberEmail,
              customerId: customerId
            },
            retry: false
          });
        case 1:
          result = _context.v;
          return _context.a(2, result);
        case 2:
          _context.p = 2;
          _t = _context.v;
          return _context.a(2, {
            traceId: _t.traceId,
            code: _t.code,
            message: _t.message,
            axiosStatus: 'error'
          });
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function getMyProfile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// 会员等级成长进度信息
var getUpgradeProgress = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(memberEmail, customerId) {
    var result, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return heteRequest('/crm/front/shopify/member/personalCenter/upgradeProgress', {
            data: {
              memberEmail: memberEmail,
              customerId: customerId
            },
            retry: false
          });
        case 1:
          result = _context2.v;
          return _context2.a(2, result);
        case 2:
          _context2.p = 2;
          _t2 = _context2.v;
          return _context2.a(2, {
            traceId: _t2.traceId,
            code: _t2.code,
            message: _t2.message,
            axiosStatus: 'error'
          });
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return function getUpgradeProgress(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}()));

// 用户查询会员权益
var getMemberBenefit = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(memberEmail, type) {
    var result, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return heteRequest('/crm/front/shopify/member/vipBenefit/v2/memberBenefit', {
            data: {
              memberEmail: memberEmail,
              type: type
            }
          });
        case 1:
          result = _context3.v;
          return _context3.a(2, result);
        case 2:
          _context3.p = 2;
          _t3 = _context3.v;
          return _context3.a(2, {
            traceId: _t3.traceId,
            code: _t3.code,
            message: _t3.message,
            axiosStatus: 'error'
          });
      }
    }, _callee3, null, [[0, 2]]);
  }));
  return function getMemberBenefit(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}()));

// 领取权益
var getReceiveBenefit = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(memberEmail, benefitType, receiveTime) {
    var result, _t4;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.p = 0;
          _context4.n = 1;
          return heteRequest('/crm/front/shopify/member/vipBenefit/v2/receiveBenefit', {
            data: {
              memberEmail: memberEmail,
              benefitType: benefitType,
              receiveTime: receiveTime
            }
          });
        case 1:
          result = _context4.v;
          return _context4.a(2, result);
        case 2:
          _context4.p = 2;
          _t4 = _context4.v;
          return _context4.a(2, {
            traceId: _t4.traceId,
            code: _t4.code,
            message: _t4.message,
            axiosStatus: 'error'
          });
      }
    }, _callee4, null, [[0, 2]]);
  }));
  return function getReceiveBenefit(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}()));

// 刷新用户每月礼、生日礼
var getRefreshMonthAndBirthdayGift = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(memberEmail) {
    var result, _t5;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          _context5.n = 1;
          return heteRequest('/crm/front/shopify/member/vipBenefit/refreshMonthAndBirthdayGift', {
            data: {
              memberEmail: memberEmail
            }
          });
        case 1:
          result = _context5.v;
          return _context5.a(2, result);
        case 2:
          _context5.p = 2;
          _t5 = _context5.v;
          return _context5.a(2, {
            traceId: _t5.traceId,
            code: _t5.code,
            message: _t5.message,
            axiosStatus: 'error'
          });
      }
    }, _callee5, null, [[0, 2]]);
  }));
  return function getRefreshMonthAndBirthdayGift(_x0) {
    return _ref5.apply(this, arguments);
  };
}()));
;// CONCATENATED MODULE: ./api/wishlist.js






function wishlist_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return wishlist_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (wishlist_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, wishlist_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, wishlist_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), wishlist_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", wishlist_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), wishlist_regeneratorDefine2(u), wishlist_regeneratorDefine2(u, o, "Generator"), wishlist_regeneratorDefine2(u, n, function () { return this; }), wishlist_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (wishlist_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function wishlist_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } wishlist_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { wishlist_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, wishlist_regeneratorDefine2(e, r, n, t); }
function wishlist_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function wishlist_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { wishlist_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { wishlist_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var safeRequest = /*#__PURE__*/function () {
  var _ref = wishlist_asyncToGenerator(/*#__PURE__*/wishlist_regenerator().m(function _callee(url, data) {
    var result, _t;
    return wishlist_regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return (0,request/* heteRequest */.xC)(url, {
            data: data,
            retry: false
          });
        case 1:
          result = _context.v;
          return _context.a(2, result);
        case 2:
          _context.p = 2;
          _t = _context.v;
          return _context.a(2, {
            traceId: _t.traceId,
            code: _t.code,
            message: _t.message,
            axiosStatus: 'error'
          });
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function safeRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var wishlist_wishlistAdd = /*#__PURE__*/function () {
  var _ref2 = wishlist_asyncToGenerator(/*#__PURE__*/wishlist_regenerator().m(function _callee2(data) {
    return wishlist_regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return safeRequest('/pdc/front/wish/add', data);
        case 1:
          return _context2.a(2, _context2.v);
      }
    }, _callee2);
  }));
  return function wishlistAdd(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var wishlistRemove = /*#__PURE__*/function () {
  var _ref3 = wishlist_asyncToGenerator(/*#__PURE__*/wishlist_regenerator().m(function _callee3(data) {
    return wishlist_regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return safeRequest('/pdc/front/wish/remove', data);
        case 1:
          return _context3.a(2, _context3.v);
      }
    }, _callee3);
  }));
  return function wishlistRemove(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var wishlist_wishlistList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = wishlist_asyncToGenerator(/*#__PURE__*/wishlist_regenerator().m(function _callee4(data) {
    return wishlist_regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return safeRequest('/pdc/front/wish/list', data);
        case 1:
          return _context4.a(2, _context4.v);
      }
    }, _callee4);
  }));
  return function wishlistList(_x5) {
    return _ref4.apply(this, arguments);
  };
}()));
var wishlist_wishlistUpdate = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = wishlist_asyncToGenerator(/*#__PURE__*/wishlist_regenerator().m(function _callee5(data) {
    return wishlist_regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return safeRequest('/pdc/front/wish/update', data);
        case 1:
          return _context5.a(2, _context5.v);
      }
    }, _callee5);
  }));
  return function wishlistUpdate(_x6) {
    return _ref5.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./utils/event-handler.js
var event_handler = __webpack_require__(25675);
// EXTERNAL MODULE: ./utils/misc.js
var misc = __webpack_require__(36792);
// EXTERNAL MODULE: ./utils/storage.js
var storage = __webpack_require__(38440);
// EXTERNAL MODULE: ./utils/store.js
var store = __webpack_require__(45837);
;// CONCATENATED MODULE: ./snippets/swym-wishlist/index.js
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





















function swym_wishlist_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return swym_wishlist_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (swym_wishlist_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, swym_wishlist_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, swym_wishlist_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), swym_wishlist_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", swym_wishlist_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), swym_wishlist_regeneratorDefine2(u), swym_wishlist_regeneratorDefine2(u, o, "Generator"), swym_wishlist_regeneratorDefine2(u, n, function () { return this; }), swym_wishlist_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (swym_wishlist_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function swym_wishlist_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } swym_wishlist_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { swym_wishlist_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, swym_wishlist_regeneratorDefine2(e, r, n, t); }
function swym_wishlist_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function swym_wishlist_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { swym_wishlist_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { swym_wishlist_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }







var syncStore = (0,storage/* default */.Z)('wishlist-sync-done', false);
var isApiError = function isApiError(result) {
  return (result === null || result === void 0 ? void 0 : result.axiosStatus) === 'error';
};
var memberCodeStore = (0,storage/* default */.Z)('wishlist-member-code');
var getMemberCode = /*#__PURE__*/function () {
  var _ref = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee() {
    var userInfo, email, cached, profile;
    return swym_wishlist_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          userInfo = store/* default */.Z.getState('userInfo');
          email = userInfo === null || userInfo === void 0 ? void 0 : userInfo.customerEmail;
          if (email) {
            _context.n = 1;
            break;
          }
          return _context.a(2, undefined);
        case 1:
          cached = memberCodeStore.get();
          if (!((cached === null || cached === void 0 ? void 0 : cached.email) === email && cached !== null && cached !== void 0 && cached.memberCode)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, cached.memberCode);
        case 2:
          _context.n = 3;
          return getMyProfile(email, userInfo.customerID);
        case 3:
          profile = _context.v;
          if (!(isApiError(profile) || !(profile !== null && profile !== void 0 && profile.memberCode))) {
            _context.n = 4;
            break;
          }
          return _context.a(2, undefined);
        case 4:
          memberCodeStore.set({
            email: email,
            memberCode: profile.memberCode
          });
          return _context.a(2, profile.memberCode);
      }
    }, _callee);
  }));
  return function getMemberCode() {
    return _ref.apply(this, arguments);
  };
}();
var syncToBackend = /*#__PURE__*/function () {
  var _ref2 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee2(apiCall, label) {
    var result;
    return swym_wishlist_regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return apiCall;
        case 1:
          result = _context2.v;
          if (isApiError(result)) {
            console.log("wishlist ".concat(label, " sync error"), result.message);
          }
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function syncToBackend(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var addSwymApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee3(product) {
    return swym_wishlist_regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function addSwymApi(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var removeSwymApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee4(product) {
    return swym_wishlist_regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return function removeSwymApi(_x4) {
    return _ref4.apply(this, arguments);
  };
}()));
var showSwymList = (0,lodash/* debounce */.Ds)(function () {
  var _window$_swat, _window$_swat$initial;
  (_window$_swat = window._swat) === null || _window$_swat === void 0 || (_window$_swat$initial = _window$_swat.initializeActionButtons) === null || _window$_swat$initial === void 0 || _window$_swat$initial.call(_window$_swat, 'Body');
}, 500);
var getSwat = function getSwat() {
  return new Promise(function (resolve, reject) {
    var swat = window._swat;
    if (swat) {
      resolve(swat);
      return;
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      if (swat) {
        resolve(swat);
      } else {
        reject(new Error('unknow error'));
      }
    });
  });
};
var getWishlist = function getWishlist(timeout) {
  var listPromise = new Promise(/*#__PURE__*/function () {
    var _ref5 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee5(resolve, reject) {
      var swat, _t;
      return swym_wishlist_regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            _context5.n = 1;
            return getSwat();
          case 1:
            swat = _context5.v;
            if (swat) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2, reject(new Error('swat not ready')));
          case 2:
            swat.fetchLists({
              callbackFn: function callbackFn(list) {
                resolve(list);
              },
              errorFn: function errorFn(error) {
                console.log('get wishlist error', error);
                reject(new Error('fetch list error'));
              }
            });
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t = _context5.v;
            reject(_t);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[0, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }());
  var timeoutPromise = new Promise(function (_resolve, reject) {
    setTimeout(function () {
      reject(new Error('timeout'));
    }, timeout);
  });
  return Promise.race([listPromise, timeoutPromise]);
};
var BACKEND_PAGE_SIZE = 99;

/**
 * 根据 totalCount 按 BACKEND_PAGE_SIZE 分页，Promise.all 批量拉取全量列表。
 * @param {string} memberCode
 * @param {number} totalCount - 后端返回的总条数
 * @returns {Promise<{ records: Array }>}
 */
var fetchAllBackendList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee6(memberCode, totalCount) {
    var total, totalPage, pages, allRecords, _iterator, _step, _result$records, result, _t2;
    return swym_wishlist_regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          total = Number(totalCount) || 0;
          if (!(total === 0)) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, {
            records: []
          });
        case 1:
          totalPage = Math.ceil(total / BACKEND_PAGE_SIZE);
          _context6.n = 2;
          return Promise.all(Array.from({
            length: totalPage
          }, function (_, index) {
            return wishlistList({
              memberCode: memberCode,
              pageNo: index + 1,
              pageSize: BACKEND_PAGE_SIZE
            });
          }));
        case 2:
          pages = _context6.v;
          allRecords = [];
          _iterator = _createForOfIteratorHelper(pages);
          _context6.p = 3;
          _iterator.s();
        case 4:
          if ((_step = _iterator.n()).done) {
            _context6.n = 7;
            break;
          }
          result = _step.value;
          if (!isApiError(result)) {
            _context6.n = 5;
            break;
          }
          return _context6.a(3, 6);
        case 5:
          allRecords.push.apply(allRecords, _toConsumableArray((_result$records = result === null || result === void 0 ? void 0 : result.records) !== null && _result$records !== void 0 ? _result$records : []));
        case 6:
          _context6.n = 4;
          break;
        case 7:
          _context6.n = 9;
          break;
        case 8:
          _context6.p = 8;
          _t2 = _context6.v;
          _iterator.e(_t2);
        case 9:
          _context6.p = 9;
          _iterator.f();
          return _context6.f(9);
        case 10:
          return _context6.a(2, {
            records: allRecords
          });
      }
    }, _callee6, null, [[3, 8, 9, 10]]);
  }));
  return function fetchAllBackendList(_x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}()));

/**
 * 合并多个 Swym 列表的 listcontents，按 SKU 维度（frontSkuCode + frontSpuCode）去重。
 * @param {Array<{ listcontents?: Array }>} infoList - fetchLists 返回的列表数组
 * @returns {Array<{ frontSkuCode: string, frontSpuCode: string, productTitle: string, productPic: string }>}
 */
var parseSwymItems = function parseSwymItems(infoList) {
  var lists = Array.isArray(infoList) ? infoList : [];
  var bySku = new Map();
  var _iterator2 = _createForOfIteratorHelper(lists),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _list$listcontents;
      var list = _step2.value;
      var contents = (_list$listcontents = list === null || list === void 0 ? void 0 : list.listcontents) !== null && _list$listcontents !== void 0 ? _list$listcontents : [];
      var _iterator3 = _createForOfIteratorHelper(contents),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _it$epi, _it$empi, _it$dt, _it$iu;
          var it = _step3.value;
          var sku = (0,misc/* stripGid */.jE)(String((_it$epi = it.epi) !== null && _it$epi !== void 0 ? _it$epi : ''));
          var spu = (0,misc/* stripGid */.jE)(String((_it$empi = it.empi) !== null && _it$empi !== void 0 ? _it$empi : ''));
          var key = "".concat(sku, "_").concat(spu);
          if (key === '_' || bySku.has(key)) continue;
          bySku.set(key, {
            frontSkuCode: sku,
            frontSpuCode: spu,
            productTitle: (_it$dt = it.dt) !== null && _it$dt !== void 0 ? _it$dt : '',
            productPic: (_it$iu = it.iu) !== null && _it$iu !== void 0 ? _it$iu : ''
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return _toConsumableArray(bySku.values());
};
var syncWishlistOnLogin = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref7 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee7() {
    var _ref8,
      _ref8$timeout,
      timeout,
      memberCode,
      startTime,
      _backendResult$totalC,
      _yield$Promise$all,
      _yield$Promise$all2,
      backendResult,
      infoList,
      swymItems,
      backendHasData,
      updateResult,
      _backendResult$totalC2,
      _fullBackendResult$re,
      fullBackendResult,
      backendSet,
      onlyInSwym,
      total,
      chunks,
      results,
      _iterator4,
      _step4,
      result,
      _args7 = arguments,
      _t3,
      _t4;
    return swym_wishlist_regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          _ref8 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, _ref8$timeout = _ref8.timeout, timeout = _ref8$timeout === void 0 ? 30000 : _ref8$timeout;
          _context7.n = 1;
          return getMemberCode();
        case 1:
          memberCode = _context7.v;
          if (memberCode) {
            _context7.n = 2;
            break;
          }
          return _context7.a(2);
        case 2:
          if (!(syncStore.get() === memberCode)) {
            _context7.n = 3;
            break;
          }
          return _context7.a(2);
        case 3:
          startTime = Date.now();
          _context7.p = 4;
          _context7.n = 5;
          return Promise.all([wishlistList({
            memberCode: memberCode,
            pageNo: 1,
            pageSize: 1
          }), getWishlist(timeout)]);
        case 5:
          _yield$Promise$all = _context7.v;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          backendResult = _yield$Promise$all2[0];
          infoList = _yield$Promise$all2[1];
          if (!isApiError(backendResult)) {
            _context7.n = 6;
            break;
          }
          console.log('sync wishlist: list api error', backendResult.message);
          return _context7.a(2);
        case 6:
          swymItems = parseSwymItems(infoList);
          backendHasData = ((_backendResult$totalC = backendResult === null || backendResult === void 0 ? void 0 : backendResult.totalCount) !== null && _backendResult$totalC !== void 0 ? _backendResult$totalC : 0) > 0;
          if (backendHasData) {
            _context7.n = 9;
            break;
          }
          if (!(swymItems.length > 0)) {
            _context7.n = 8;
            break;
          }
          _context7.n = 7;
          return wishlistUpdate({
            memberCode: memberCode,
            products: swymItems
          });
        case 7:
          updateResult = _context7.v;
          if (!isApiError(updateResult)) {
            _context7.n = 8;
            break;
          }
          console.log('sync wishlist: update error', updateResult.message);
          return _context7.a(2);
        case 8:
          _context7.n = 19;
          break;
        case 9:
          if (!(swymItems.length > 0)) {
            _context7.n = 19;
            break;
          }
          _context7.n = 10;
          return fetchAllBackendList(memberCode, (_backendResult$totalC2 = backendResult === null || backendResult === void 0 ? void 0 : backendResult.totalCount) !== null && _backendResult$totalC2 !== void 0 ? _backendResult$totalC2 : 0);
        case 10:
          fullBackendResult = _context7.v;
          if (!isApiError(fullBackendResult)) {
            _context7.n = 11;
            break;
          }
          console.log('sync wishlist: full list error', fullBackendResult.message);
          return _context7.a(2);
        case 11:
          backendSet = new Set(((_fullBackendResult$re = fullBackendResult === null || fullBackendResult === void 0 ? void 0 : fullBackendResult.records) !== null && _fullBackendResult$re !== void 0 ? _fullBackendResult$re : []).map(function (it) {
            return "".concat(it.frontSkuCode, "_").concat(it.frontSpuCode);
          }));
          onlyInSwym = swymItems.filter(function (it) {
            return !backendSet.has("".concat(it.frontSkuCode, "_").concat(it.frontSpuCode));
          });
          if (!(onlyInSwym.length > 0)) {
            _context7.n = 19;
            break;
          }
          total = onlyInSwym.length;
          chunks = Array.from({
            length: Math.ceil(total / BACKEND_PAGE_SIZE)
          }, function (_, index) {
            return onlyInSwym.slice(index * BACKEND_PAGE_SIZE, (index + 1) * BACKEND_PAGE_SIZE);
          });
          _context7.n = 12;
          return Promise.all(chunks.map(function (products) {
            return wishlistAdd({
              memberCode: memberCode,
              products: products
            });
          }));
        case 12:
          results = _context7.v;
          _iterator4 = _createForOfIteratorHelper(results);
          _context7.p = 13;
          _iterator4.s();
        case 14:
          if ((_step4 = _iterator4.n()).done) {
            _context7.n = 16;
            break;
          }
          result = _step4.value;
          if (!isApiError(result)) {
            _context7.n = 15;
            break;
          }
          console.log('sync wishlist: add error', result.message);
          return _context7.a(2);
        case 15:
          _context7.n = 14;
          break;
        case 16:
          _context7.n = 18;
          break;
        case 17:
          _context7.p = 17;
          _t3 = _context7.v;
          _iterator4.e(_t3);
        case 18:
          _context7.p = 18;
          _iterator4.f();
          return _context7.f(18);
        case 19:
          console.log('sync wishlist done', Date.now() - startTime);
          syncStore.set(memberCode);
          _context7.n = 21;
          break;
        case 20:
          _context7.p = 20;
          _t4 = _context7.v;
          console.log('sync wishlist error', Date.now() - startTime, _t4);
        case 21:
          return _context7.a(2);
      }
    }, _callee7, null, [[13, 17, 18, 19], [4, 20]]);
  }));
  return function syncWishlistOnLogin() {
    return _ref7.apply(this, arguments);
  };
}()));
var REMOVE_BATCH_SIZE = 99;
var originalSwynEventObserver = /*#__PURE__*/function () {
  var _ref9 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee1() {
    var addWithListEvent, removeWithListEvent, swat;
    return swym_wishlist_regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          (0,event_handler.on)('click', '.swym-modal .swym-clear-wishlist-btn', /*#__PURE__*/swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee8() {
            var memberCode, infoList, items, frontSkuCodes, index, chunk, _t5;
            return swym_wishlist_regenerator().w(function (_context8) {
              while (1) switch (_context8.p = _context8.n) {
                case 0:
                  _context8.n = 1;
                  return getMemberCode();
                case 1:
                  memberCode = _context8.v;
                  if (memberCode) {
                    _context8.n = 2;
                    break;
                  }
                  return _context8.a(2);
                case 2:
                  _context8.p = 2;
                  _context8.n = 3;
                  return getWishlist(10000);
                case 3:
                  infoList = _context8.v;
                  items = parseSwymItems(infoList);
                  frontSkuCodes = items.map(function (it) {
                    return it.frontSkuCode;
                  }).filter(Boolean);
                  if (!(frontSkuCodes.length === 0)) {
                    _context8.n = 4;
                    break;
                  }
                  return _context8.a(2);
                case 4:
                  index = 0;
                case 5:
                  if (!(index < frontSkuCodes.length)) {
                    _context8.n = 7;
                    break;
                  }
                  chunk = frontSkuCodes.slice(index, index + REMOVE_BATCH_SIZE).map(function (item) {
                    return (0,misc/* stripGid */.jE)(item);
                  });
                  _context8.n = 6;
                  return syncToBackend(wishlistRemove({
                    memberCode: memberCode,
                    frontSkuCodes: chunk
                  }), 'clear');
                case 6:
                  index += REMOVE_BATCH_SIZE;
                  _context8.n = 5;
                  break;
                case 7:
                  _context8.n = 9;
                  break;
                case 8:
                  _context8.p = 8;
                  _t5 = _context8.v;
                  console.log('clear wishlist error', _t5);
                case 9:
                  return _context8.a(2);
              }
            }, _callee8, null, [[2, 8]]);
          })), {
            capture: true
          });
          addWithListEvent = 'sw:addedtowishlist';
          removeWithListEvent = 'sw:removedfromwishlist';
          _context1.n = 1;
          return getSwat();
        case 1:
          swat = _context1.v;
          swat.evtLayer.addEventListener(addWithListEvent, /*#__PURE__*/function () {
            var _ref1 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee9(listener) {
              var current, memberCode, _current$dt, _current$iu;
              return swym_wishlist_regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    current = listener.detail.d;
                    _context9.n = 1;
                    return getMemberCode();
                  case 1:
                    memberCode = _context9.v;
                    if (memberCode) {
                      syncToBackend(wishlist_wishlistAdd({
                        memberCode: memberCode,
                        products: [{
                          frontSkuCode: (0,misc/* stripGid */.jE)(String(current.epi)),
                          frontSpuCode: (0,misc/* stripGid */.jE)(String(current.empi)),
                          productTitle: (_current$dt = current.dt) !== null && _current$dt !== void 0 ? _current$dt : '',
                          productPic: (_current$iu = current.iu) !== null && _current$iu !== void 0 ? _current$iu : ''
                        }]
                      }), 'add');
                    }
                  case 2:
                    return _context9.a(2);
                }
              }, _callee9);
            }));
            return function (_x9) {
              return _ref1.apply(this, arguments);
            };
          }());
          swat.evtLayer.addEventListener(removeWithListEvent, /*#__PURE__*/function () {
            var _ref10 = swym_wishlist_asyncToGenerator(/*#__PURE__*/swym_wishlist_regenerator().m(function _callee0(listener) {
              var memberCode;
              return swym_wishlist_regenerator().w(function (_context0) {
                while (1) switch (_context0.n) {
                  case 0:
                    _context0.n = 1;
                    return getMemberCode();
                  case 1:
                    memberCode = _context0.v;
                    if (memberCode) {
                      syncToBackend(wishlistRemove({
                        memberCode: memberCode,
                        frontSkuCodes: [(0,misc/* stripGid */.jE)(String(listener.detail.d.epi))]
                      }), 'remove');
                    }
                  case 2:
                    return _context0.a(2);
                }
              }, _callee0);
            }));
            return function (_x0) {
              return _ref10.apply(this, arguments);
            };
          }());
        case 2:
          return _context1.a(2);
      }
    }, _callee1);
  }));
  return function originalSwynEventObserver() {
    return _ref9.apply(this, arguments);
  };
}();
var init = function init() {
  originalSwynEventObserver();
};
init();

// EXTERNAL MODULE: ./utils/rIC.js
var rIC = __webpack_require__(24681);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(35659);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(66066);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(36763);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(86028);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(84750);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(77991);
// EXTERNAL MODULE: ../node_modules/core-js/modules/esnext.string.replace-all.js
var esnext_string_replace_all = __webpack_require__(26956);
// EXTERNAL MODULE: ./snippets/original-main-product/quick-add-to-cart/index.js + 1 modules
var quick_add_to_cart = __webpack_require__(98120);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(92815);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__(64528);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(48075);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(48349);
// EXTERNAL MODULE: ../node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(32904);
// EXTERNAL MODULE: ./utils/impression-tracking.js
var impression_tracking = __webpack_require__(85097);
// EXTERNAL MODULE: ./utils/number-precision.js
var number_precision = __webpack_require__(69784);
;// CONCATENATED MODULE: ./snippets/product-card-group/item/src/event-tracking.js
function event_tracking_slicedToArray(r, e) { return event_tracking_arrayWithHoles(r) || event_tracking_iterableToArrayLimit(r, e) || event_tracking_unsupportedIterableToArray(r, e) || event_tracking_nonIterableRest(); }
function event_tracking_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function event_tracking_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return event_tracking_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? event_tracking_arrayLikeToArray(r, a) : void 0; } }
function event_tracking_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function event_tracking_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function event_tracking_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
























var getProductEcommerce = function getProductEcommerce(target) {
  return {
    item_list_id: target.dataset.listId,
    item_list_name: target.dataset.listName,
    item_category: target.dataset.productType,
    item_id: target.dataset.productId,
    item_name: target.dataset.productTitle,
    item_variant: target.dataset.variantSku,
    item_category5: target.dataset.variantSku,
    item_brand: target.dataset.variantTitle,
    item_category4: target.dataset.variantId,
    price: Number(target.dataset.price),
    index: target.dataset.index,
    quantity: '1',
    currency: 'USD',
    flow_group: 'none'
  };
};
var productImpression = (0,lodash/* debounce */.Ds)(function () {
  (0,impression_tracking/* default */.Z)('.product-card-group .product-card-group__item', function () {
    var targetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if ((targetList === null || targetList === void 0 ? void 0 : targetList.length) === 0) {
      return;
    }
    var items = targetList.map(function (item) {
      return getProductEcommerce(item);
    });
    var price = items.reduce(function (r, item) {
      r = number_precision/* default */.Z.plus(r, item.price);
      return r;
    }, 0);
    if (!Number.isFinite(price) || price < 0) {
      return;
    }
    var data = {
      event: 'eeEvent',
      event_type: 'view_item_list',
      ecommerce: {
        event_label: 'Product Card Group',
        currency: 'USD',
        value: price,
        product_id: '',
        items: items
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  }, false, true, 500);
  (0,impression_tracking/* default */.Z)('.product-card-group__item:not(.product-card-group .product-card-group__item)', function () {
    var _firstElement$dataset;
    var targetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if ((targetList === null || targetList === void 0 ? void 0 : targetList.length) === 0) {
      return;
    }
    var _targetList = event_tracking_slicedToArray(targetList, 1),
      firstElement = _targetList[0];
    var event_label = '';
    var items = targetList.map(function (item) {
      return getProductEcommerce(item);
    });
    if (firstElement !== null && firstElement !== void 0 && firstElement.closest('.main-search')) {
      event_label = 'search_preview';
    }
    if (window.location.pathname === '/search') {
      var parameters = new URLSearchParams(window.location.search);
      var searchInput = parameters.get('q') || '';
      event_label = 'search_' + searchInput;
    }
    if (firstElement !== null && firstElement !== void 0 && firstElement.closest('.tuga-product-card')) {
      event_label = 'Tuga Product Card';
    }
    var price = items.reduce(function (r, item) {
      r = number_precision/* default */.Z.plus(r, item.price);
      return r;
    }, 0);
    if (!Number.isFinite(price) || price < 0) {
      return;
    }
    var data = {
      event: 'eeEvent',
      event_type: 'view_item_list',
      ecommerce: {
        currency: 'USD',
        value: price,
        product_id: (firstElement === null || firstElement === void 0 || (_firstElement$dataset = firstElement.dataset) === null || _firstElement$dataset === void 0 ? void 0 : _firstElement$dataset.productId) || '',
        items: items,
        event_label: event_label
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  }, false, true, 500);
}, 1000);
var productCardGroupTracking = function productCardGroupTracking() {
  (0,event_handler.on)('click', '.product-card-group__item', function (event) {
    var currentTarget = event.currentTarget,
      target = event.target;
    if (target.closest('.product-card-group__handler') || target.closest('.carousel__arrow') || target.closest('.quickbuy-overlay')) {
      return;
    }
    if (!currentTarget.closest('.product-card-group__tabs')) {
      return;
    }
    var data = {
      event: 'eeEvent',
      event_type: 'select_item',
      ecommerce: {
        event_label: 'Product Card Group',
        value: currentTarget.dataset.price,
        currency: 'USD',
        product_id: '',
        items: [getProductEcommerce(currentTarget)]
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  });
  (0,event_handler.on)('click', '.product-card-group__item:not(.product-card-group .product-card-group__item)', function (event) {
    var _currentTarget$datase;
    var currentTarget = event.currentTarget,
      target = event.target;
    if (target.closest('.product-card-group__handler') || target.closest('.carousel__arrow') || target.closest('.quickbuy-overlay')) {
      return;
    }
    var event_label = '';
    if (currentTarget.closest('.related-products')) {
      event_label = currentTarget.closest('.related-products').getAttribute('product-title');
    } else if (currentTarget.closest('.product-recommendation')) {
      event_label = currentTarget.closest('.product-recommendation').getAttribute('product-title');
    } else if (currentTarget.closest('featured-collection')) {
      event_label = 'Featured_collection';
    } else if (currentTarget.closest('.tuga-product-card')) {
      event_label = 'Tuga Product Card';
    }
    var data = {
      event: 'eeEvent',
      event_type: 'select_item',
      ecommerce: {
        value: currentTarget.dataset.price,
        currency: 'USD',
        product_id: (currentTarget === null || currentTarget === void 0 || (_currentTarget$datase = currentTarget.dataset) === null || _currentTarget$datase === void 0 ? void 0 : _currentTarget$datase.productId) || '',
        items: [getProductEcommerce(currentTarget)]
      },
      event_label: event_label
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  });
  (0,event_handler.on)('click', '.product-card-group__item .product-card-group__item__swym-button', function (event) {
    var _wrapperElement$datas;
    var currentTarget = event.currentTarget;
    if (currentTarget.classList.contains('disabled')) {
      return;
    }
    var wrapperElement = currentTarget.closest('.product-card-group__item');
    var event_label = '';
    if (wrapperElement.closest('.related-products')) {
      event_label = wrapperElement.closest('.related-products').getAttribute('product-title');
    } else if (wrapperElement.closest('.product-recommendation')) {
      event_label = wrapperElement.closest('.product-recommendation').getAttribute('product-title');
    } else if (wrapperElement.closest('featured-collection')) {
      event_label = 'Featured_collection';
    }
    var data = {
      event: 'eeEvent',
      event_type: 'add_to_wishlist',
      ecommerce: {
        value: wrapperElement.dataset.price,
        currency: 'USD',
        product_id: (wrapperElement === null || wrapperElement === void 0 || (_wrapperElement$datas = wrapperElement.dataset) === null || _wrapperElement$datas === void 0 ? void 0 : _wrapperElement$datas.productId) || '',
        items: [getProductEcommerce(wrapperElement)],
        event_label: event_label
      }
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  }, {
    capture: true
  });
  (0,event_handler.on)('click', '.product-card-group__footer__more,.product-card-group__header__more', function (event) {
    var _currentTarget$closes;
    var currentTarget = event.currentTarget;
    var title = ((_currentTarget$closes = currentTarget.closest('product-card-group')) === null || _currentTarget$closes === void 0 || (_currentTarget$closes = _currentTarget$closes.querySelector('.product-card-group__header__title')) === null || _currentTarget$closes === void 0 ? void 0 : _currentTarget$closes.textContent) || 'none';
    var href = currentTarget.getAttribute('href') || 'none';
    if (href !== 'none' && !href.startsWith('http')) {
      href = "".concat(location.origin).concat(href);
    }
    var data = {
      event: 'uaEvent',
      event_type: 'collection_entrance',
      event_label: "".concat(title, "_View All"),
      creative_name: href
    };
    window.dataLayer.push({
      ecommerce: null
    }, data);
  });
};

/* harmony default export */ var event_tracking = (productCardGroupTracking);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__(44350);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(44901);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(19131);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__(9815);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(21413);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(81597);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(86651);
// EXTERNAL MODULE: ./api/ab-test.js
var ab_test = __webpack_require__(84061);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(89034);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__(20433);
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(78305);
;// CONCATENATED MODULE: ./api/product.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function product_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = product_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function product_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return product_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (product_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, product_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, product_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), product_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", product_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), product_regeneratorDefine2(u), product_regeneratorDefine2(u, o, "Generator"), product_regeneratorDefine2(u, n, function () { return this; }), product_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (product_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function product_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } product_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { product_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, product_regeneratorDefine2(e, r, n, t); }
function product_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function product_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { product_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { product_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function product_toConsumableArray(r) { return product_arrayWithoutHoles(r) || product_iterableToArray(r) || product_unsupportedIterableToArray(r) || product_nonIterableSpread(); }
function product_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function product_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return product_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? product_arrayLikeToArray(r, a) : void 0; } }
function product_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function product_arrayWithoutHoles(r) { if (Array.isArray(r)) return product_arrayLikeToArray(r); }
function product_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




























var SHOPIFY_PRODUCT_GID_PATTERN = /^gid:\/\/shopify\/Product\/(\d+)$/;
var SHOPIFY_GID_PATTERN = /^gid:\/\/shopify\/[^/]+\/([^#/?]+)$/;

/**
 * @typedef {object} ProductCollectionIds
 * @property {string} productId
 * @property {string[]} collIds
 */

/**
 * @typedef {object} ProductCollectionIdsOptions
 * @property {AbortSignal} [signal]
 * @property {boolean} [isRepeatCancellation]
 */

/**
 * 将纯数字商品 ID 转换为 Shopify Product GID。
 * @param {string} productId
 * @returns {string}
 */
var normalizeProductGid = function normalizeProductGid(productId) {
  var id = String(productId !== null && productId !== void 0 ? productId : '').trim();
  if (/^\d+$/.test(id)) return "gid://shopify/Product/".concat(id);
  return SHOPIFY_PRODUCT_GID_PATTERN.test(id) ? id : '';
};

/**
 * 截取 Shopify GID 中的纯 ID，并始终以字符串返回。
 * @param {string} gid
 * @returns {string}
 */
var stripShopifyGid = function stripShopifyGid(gid) {
  var _id$match;
  var id = String(gid !== null && gid !== void 0 ? gid : '').trim();
  return ((_id$match = id.match(SHOPIFY_GID_PATTERN)) === null || _id$match === void 0 ? void 0 : _id$match[1]) || '';
};

/**
 * 从 Storefront 商品数据中提取去重后的 Collection IDs。
 * @param {object|null|undefined} product
 * @returns {string[]}
 */
var extractCollectionIds = function extractCollectionIds(product) {
  var _product$collections;
  return product_toConsumableArray(new Set(((product === null || product === void 0 || (_product$collections = product.collections) === null || _product$collections === void 0 ? void 0 : _product$collections.edges) || []).map(function (edge) {
    var _edge$node;
    return stripShopifyGid(edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.id);
  }).filter(Boolean)));
};
var buildProductCollectionIdsQuery = function buildProductCollectionIdsQuery(productGids) {
  var variableDefinitions = productGids.map(function (_, index) {
    return "$productId_".concat(index + 1, ": ID!");
  }).join(', ');
  var products = productGids.map(function (_, index) {
    return "\n        product_".concat(index + 1, ": product(id: $productId_").concat(index + 1, ") {\n          id\n          collections(first: 250) {\n            edges {\n              node {\n                id\n              }\n            }\n          }\n        }\n      ");
  }).join('\n');
  return "query GetProductCollectionIds(".concat(variableDefinitions, ") {\n    ").concat(products, "\n  }");
};
var requestProductCollectionIds = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee(productGids) {
    var options,
      variables,
      _args = arguments;
    return product_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          if (!(productGids.length === 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, {});
        case 1:
          variables = Object.fromEntries(productGids.map(function (gid, index) {
            return ["productId_".concat(index + 1), gid];
          }));
          _context.n = 2;
          return storeFrontRequest(buildProductCollectionIdsQuery(productGids), variables, {
            retry: false,
            signal: options.signal,
            isRepeatCancellation: options.isRepeatCancellation
          });
        case 2:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function requestProductCollectionIds(_x) {
    return _ref.apply(this, arguments);
  };
}()));

/**
 * 根据一个或多个 Shopify 商品 ID 获取所属 Collection IDs。
 * @param {string|string[]} productIds
 * @param {ProductCollectionIdsOptions} [options]
 * @returns {Promise<ProductCollectionIds[]>}
 */
var getProductCollectionIds = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee3(productIds) {
    var options,
      input,
      productGids,
      response,
      _options$signal,
      products,
      _args3 = arguments,
      _t2;
    return product_regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          input = Array.isArray(productIds) ? productIds : [productIds];
          productGids = product_toConsumableArray(new Set(input.map(function (id) {
            return normalizeProductGid(id);
          }).filter(Boolean)));
          if (!(productGids.length === 0)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, []);
        case 1:
          _context3.p = 1;
          _context3.n = 2;
          return requestProductCollectionIds(productGids, options);
        case 2:
          response = _context3.v;
          _context3.n = 6;
          break;
        case 3:
          _context3.p = 3;
          _t2 = _context3.v;
          if (!((_options$signal = options.signal) !== null && _options$signal !== void 0 && _options$signal.aborted)) {
            _context3.n = 4;
            break;
          }
          throw _t2;
        case 4:
          _context3.n = 5;
          return Promise.all(productGids.map(/*#__PURE__*/function () {
            var _ref3 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee2(gid) {
              var result, _options$signal2, _t;
              return product_regenerator().w(function (_context2) {
                while (1) switch (_context2.p = _context2.n) {
                  case 0:
                    _context2.p = 0;
                    _context2.n = 1;
                    return requestProductCollectionIds([gid], options);
                  case 1:
                    result = _context2.v;
                    return _context2.a(2, result === null || result === void 0 ? void 0 : result.product_1);
                  case 2:
                    _context2.p = 2;
                    _t = _context2.v;
                    if (!((_options$signal2 = options.signal) !== null && _options$signal2 !== void 0 && _options$signal2.aborted)) {
                      _context2.n = 3;
                      break;
                    }
                    throw _t;
                  case 3:
                    return _context2.a(2, undefined);
                }
              }, _callee2, null, [[0, 2]]);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()));
        case 5:
          products = _context3.v;
          return _context3.a(2, productGids.map(function (gid, index) {
            return {
              productId: stripShopifyGid(gid),
              collIds: extractCollectionIds(products[index])
            };
          }));
        case 6:
          return _context3.a(2, productGids.map(function (gid, index) {
            var _response;
            return {
              productId: stripShopifyGid(gid),
              collIds: extractCollectionIds((_response = response) === null || _response === void 0 ? void 0 : _response["product_".concat(index + 1)])
            };
          }));
      }
    }, _callee3, null, [[1, 3]]);
  }));
  return function getProductCollectionIds(_x2) {
    return _ref2.apply(this, arguments);
  };
}()));
var productFields = "\n  id\n  title\n  tags\n  handle\n  onlineStoreUrl\n  productType\n  collections(first: 250) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  metafields(identifiers: [\n    { namespace: \"custom\", key: \"flash_sale_text\" },\n    { namespace: \"custom\", key: \"product_main_image_\" },\n    { namespace: \"hetesalemeta\", key: \"ht_pdccategory\" }\n  ]) {\n    key\n    namespace\n    value\n    reference {\n      ... on MediaImage {\n        image {\n          url\n        }\n      }\n      ... on GenericFile {\n        url\n      }\n    }\n  }\n  media(first: 20) {\n    edges {\n      node {\n        mediaContentType\n        alt\n        ...mediaFieldsByType\n      }\n    }\n  }\n  variants(first: 100) {\n    nodes {\n      id\n      quantityAvailable\n      title\n      image {\n        url\n      }\n      price {\n        amount\n      }\n      compareAtPrice {\n        amount\n      }\n      sku\n      selectedOptions {\n        name\n        value\n      }\n      metafields(identifiers: [{ namespace: \"hetesalemeta\", key: \"ht_vip_price\" }]) {\n        key\n        value\n      }\n    }\n  }";

/**
 * 商品卡 AB 替换只需由新 SPU 解析 handle，避免加载完整商品、媒体、变体与 metafields。
 *
 * @param {string[]} spuCodeList
 * @returns {Promise<Array<{ id: string, handle: string }>>}
 */
var getProductHandlesBySpuCode = /*#__PURE__*/function () {
  var _ref4 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee4() {
    var spuCodeList,
      productIds,
      query,
      response,
      _args4 = arguments;
    return product_regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          spuCodeList = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : [];
          productIds = product_toConsumableArray(new Set(spuCodeList.map(function (id) {
            return String(id !== null && id !== void 0 ? id : '').trim();
          }).filter(Boolean)));
          if (!(productIds.length === 0)) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2, []);
        case 1:
          query = "\n    query {\n      ".concat(productIds.map(function (id, index) {
            return "\n            product".concat(index + 1, ": product(id: \"gid://shopify/Product/").concat(id, "\") {\n              id\n              handle\n            }\n          ");
          }).join('\n'), "\n    }\n  ");
          _context4.n = 2;
          return (0,request/* storeFrontRequest */.Mz)(query);
        case 2:
          response = _context4.v;
          return _context4.a(2, Object.values(response).filter(Boolean));
      }
    }, _callee4);
  }));
  return function getProductHandlesBySpuCode() {
    return _ref4.apply(this, arguments);
  };
}();
var getProductForProductBlockBySpuCode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee5(spuCodeList) {
    var productIds, query, resp;
    return product_regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          productIds = spuCodeList !== null && spuCodeList !== void 0 ? spuCodeList : [];
          query = "\n    query {\n      ".concat(productIds.map(function (id, index) {
            return "\n            product".concat(index + 1, ": product(id: \"gid://shopify/Product/").concat(id, "\") {\n              ").concat(productFields, "\n            }\n          ");
          }).join('\n'), "\n    }\n    fragment mediaFieldsByType on Media {\n      ... on MediaImage {\n        image {\n          url\n        }\n      }\n    }\n  ");
          _context5.n = 1;
          return storeFrontRequest(query);
        case 1:
          resp = _context5.v;
          return _context5.a(2, Object.values(resp).filter(function (it) {
            return !isEmpty(it);
          }));
      }
    }, _callee5);
  }));
  return function getProductForProductBlockBySpuCode(_x4) {
    return _ref5.apply(this, arguments);
  };
}()));
var getProductForProductBlockByHandles = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee6() {
    var handleList,
      query,
      resp,
      _args6 = arguments;
    return product_regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          handleList = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [];
          query = "\n    query {\n      ".concat(handleList.map(function (handle, index) {
            return "\n            product".concat(index + 1, ": product(handle:\"").concat(handle, "\") {\n              ").concat(productFields, "\n            }\n          ");
          }).join('\n'), "\n    }\n    fragment mediaFieldsByType on Media {\n      ... on MediaImage {\n        image {\n          url\n        }\n      }\n    }\n  ");
          _context6.n = 1;
          return storeFrontRequest(query);
        case 1:
          resp = _context6.v;
          return _context6.a(2, Object.values(resp).filter(function (it) {
            return !isEmpty(it);
          }));
      }
    }, _callee6);
  }));
  return function getProductForProductBlockByHandles() {
    return _ref6.apply(this, arguments);
  };
}()));

// 订单列表
var orderList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref7 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee7(data) {
    var result, _t3;
    return product_regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          _context7.p = 0;
          _context7.n = 1;
          return heteRequest('/oms/front/shopify/order/list', {
            data: data,
            retry: false
          });
        case 1:
          result = _context7.v;
          return _context7.a(2, result);
        case 2:
          _context7.p = 2;
          _t3 = _context7.v;
          return _context7.a(2, {
            traceId: _t3.traceId,
            code: _t3.code,
            message: _t3.message,
            axiosStatus: 'error'
          });
      }
    }, _callee7, null, [[0, 2]]);
  }));
  return function orderList(_x5) {
    return _ref7.apply(this, arguments);
  };
}()));
var orderListWithMetafield = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref8 = product_asyncToGenerator(/*#__PURE__*/product_regenerator().m(function _callee8(data) {
    var _result$records$reduc, _result$records;
    var result, productIdList, query, _result$records2, metafieldResult, productListWithMetafield, _iterator2, _step2, _item$productList2, item, _iterator3, _step3, _loop, _t4, _t5, _t6;
    return product_regenerator().w(function (_context9) {
      while (1) switch (_context9.p = _context9.n) {
        case 0:
          _context9.n = 1;
          return orderList(data);
        case 1:
          result = _context9.v;
          if (!(result.axiosStatus === 'error')) {
            _context9.n = 2;
            break;
          }
          return _context9.a(2, result);
        case 2:
          productIdList = product_toConsumableArray(new Set((_result$records$reduc = (_result$records = result.records) === null || _result$records === void 0 ? void 0 : _result$records.reduce(function (r, item) {
            var _item$productList;
            var _iterator = product_createForOfIteratorHelper((_item$productList = item.productList) !== null && _item$productList !== void 0 ? _item$productList : []),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var product = _step.value;
                if (product.productType !== 'GIFT' && product.frontSpuCode) {
                  r.push(product.frontSpuCode);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return r;
          }, [])) !== null && _result$records$reduc !== void 0 ? _result$records$reduc : []));
          if (!(productIdList.length === 0)) {
            _context9.n = 3;
            break;
          }
          return _context9.a(2, result);
        case 3:
          query = "\n    query {\n      ".concat(productIdList.map(function (id, index) {
            return "\n            product".concat(index, ": product(id: \"gid://shopify/Product/").concat(id, "\") {\n              id\n              metafield(namespace: \"hetesalemeta\", key: \"ht_how_to\") {\n                value\n                key\n                namespace\n              }\n            }\n          ");
          }).join('\n'), "\n    }\n  ");
          _context9.p = 4;
          _context9.n = 5;
          return storeFrontRequest(query, undefined, {
            retry: false
          });
        case 5:
          metafieldResult = _context9.v;
          productListWithMetafield = Object.values(metafieldResult).filter(Boolean);
          _iterator2 = product_createForOfIteratorHelper((_result$records2 = result.records) !== null && _result$records2 !== void 0 ? _result$records2 : []);
          _context9.p = 6;
          _iterator2.s();
        case 7:
          if ((_step2 = _iterator2.n()).done) {
            _context9.n = 15;
            break;
          }
          item = _step2.value;
          _iterator3 = product_createForOfIteratorHelper((_item$productList2 = item.productList) !== null && _item$productList2 !== void 0 ? _item$productList2 : []);
          _context9.p = 8;
          _loop = /*#__PURE__*/product_regenerator().m(function _loop() {
            var product, current;
            return product_regenerator().w(function (_context8) {
              while (1) switch (_context8.n) {
                case 0:
                  product = _step3.value;
                  current = productListWithMetafield.find(function (m) {
                    var _m$id, _m$id$match, _m$metafield;
                    return ((_m$id = m.id) === null || _m$id === void 0 || (_m$id$match = _m$id.match) === null || _m$id$match === void 0 || (_m$id$match = _m$id$match.call(_m$id, /(\d+)$/)) === null || _m$id$match === void 0 ? void 0 : _m$id$match[1]) === product.frontSpuCode && ((_m$metafield = m.metafield) === null || _m$metafield === void 0 ? void 0 : _m$metafield.value) && product.productType !== 'GIFT';
                  });
                  if (current) {
                    product.metafield = current.metafield;
                  }
                case 1:
                  return _context8.a(2);
              }
            }, _loop);
          });
          _iterator3.s();
        case 9:
          if ((_step3 = _iterator3.n()).done) {
            _context9.n = 11;
            break;
          }
          return _context9.d(_regeneratorValues(_loop()), 10);
        case 10:
          _context9.n = 9;
          break;
        case 11:
          _context9.n = 13;
          break;
        case 12:
          _context9.p = 12;
          _t4 = _context9.v;
          _iterator3.e(_t4);
        case 13:
          _context9.p = 13;
          _iterator3.f();
          return _context9.f(13);
        case 14:
          _context9.n = 7;
          break;
        case 15:
          _context9.n = 17;
          break;
        case 16:
          _context9.p = 16;
          _t5 = _context9.v;
          _iterator2.e(_t5);
        case 17:
          _context9.p = 17;
          _iterator2.f();
          return _context9.f(17);
        case 18:
          return _context9.a(2, result);
        case 19:
          _context9.p = 19;
          _t6 = _context9.v;
          return _context9.a(2, {
            code: _t6.code,
            message: _t6.message,
            axiosStatus: 'error'
          });
      }
    }, _callee8, null, [[8, 12, 13, 14], [6, 16, 17, 18], [4, 19]]);
  }));
  return function orderListWithMetafield(_x6) {
    return _ref8.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./utils/dayjs.js
var dayjs = __webpack_require__(13931);
// EXTERNAL MODULE: ./snippets/product-card-group/item/src/get-product-card-group-item-list.js
var get_product_card_group_item_list = __webpack_require__(12811);
;// CONCATENATED MODULE: ./snippets/product-card-group/item/src/utils.js
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == utils_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == utils_typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != utils_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != utils_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function utils_regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return utils_regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (utils_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, utils_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, utils_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), utils_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", utils_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), utils_regeneratorDefine2(u), utils_regeneratorDefine2(u, o, "Generator"), utils_regeneratorDefine2(u, n, function () { return this; }), utils_regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (utils_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function utils_regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } utils_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { utils_regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, utils_regeneratorDefine2(e, r, n, t); }
function utils_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function utils_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { utils_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { utils_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function utils_toConsumableArray(r) { return utils_arrayWithoutHoles(r) || utils_iterableToArray(r) || utils_unsupportedIterableToArray(r) || utils_nonIterableSpread(); }
function utils_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function utils_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function utils_arrayWithoutHoles(r) { if (Array.isArray(r)) return utils_arrayLikeToArray(r); }
function utils_typeof(o) { "@babel/helpers - typeof"; return utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, utils_typeof(o); }
function utils_slicedToArray(r, e) { return utils_arrayWithHoles(r) || utils_iterableToArrayLimit(r, e) || utils_unsupportedIterableToArray(r, e) || utils_nonIterableRest(); }
function utils_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function utils_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function utils_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function utils_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = utils_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function utils_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return utils_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? utils_arrayLikeToArray(r, a) : void 0; } }
function utils_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }













































var EXPERIMENT_TYPE = 'PAGE_REDIRECT';
var BATCH_SIZE = 50;
var CACHE_DURATION_HOURS = 24;
var EXPERIMENT_CACHE_KEY = 'PRODUCT_CARD_GROUP_PAGE_REDIRECT_SPU_MAPPING';
var queuedItems = new Map();
var isFlushing = false;
var toSpuCode = function toSpuCode(value) {
  var _String$trim$match;
  return ((_String$trim$match = String(value !== null && value !== void 0 ? value : '').trim().match(/(\d+)$/)) === null || _String$trim$match === void 0 ? void 0 : _String$trim$match[1]) || '';
};
var getMatchRuleParameters = function getMatchRuleParameters() {
  var parameters = (0,misc/* parameter2Object */.pO)(location.href);
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign'];
  var hasUtmParameter = utmKeys.some(function (key) {
    return parameters[key];
  });
  if (!hasUtmParameter) {
    var _iterator = utils_createForOfIteratorHelper(utmKeys),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _localStorage$getItem;
        var key = _step.value;
        parameters[key] = (_localStorage$getItem = localStorage.getItem(key)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '';
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return Object.entries(parameters).map(function (_ref) {
    var _ref2 = utils_slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    return {
      name: name,
      value: String(value !== null && value !== void 0 ? value : '')
    };
  });
};
var getMatchRuleParameterCacheKey = function getMatchRuleParameterCacheKey() {
  var matchRuleParameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return JSON.stringify(matchRuleParameter.map(function (_ref3) {
    var name = _ref3.name,
      value = _ref3.value;
    return {
      name: String(name !== null && name !== void 0 ? name : ''),
      value: String(value !== null && value !== void 0 ? value : '')
    };
  }).sort(function (left, right) {
    var nameOrder = left.name.localeCompare(right.name);
    return nameOrder || left.value.localeCompare(right.value);
  }));
};
var getDefaultCacheExpirationTime = function getDefaultCacheExpirationTime() {
  return (0,dayjs/* default */.ZP)().add(CACHE_DURATION_HOURS, 'hour').valueOf();
};
var getExperimentCacheExpirationTime = function getExperimentCacheExpirationTime(expirationTime) {
  var defaultExpirationTime = getDefaultCacheExpirationTime();
  var experimentExpirationTime = Number(expirationTime);
  if (!Number.isFinite(experimentExpirationTime)) return defaultExpirationTime;
  if (!(0,dayjs/* default */.ZP)(experimentExpirationTime).isAfter((0,dayjs/* default */.ZP)())) {
    return defaultExpirationTime;
  }
  return Math.min(defaultExpirationTime, experimentExpirationTime);
};
var readCachedExperimentMappings = function readCachedExperimentMappings(matchRuleParameterCacheKey) {
  var cachedValue = (0,storage/* default */.Z)(EXPERIMENT_CACHE_KEY).get();
  var cachedMappings = cachedValue === null || cachedValue === void 0 ? void 0 : cachedValue.spuMappings;
  if ((cachedValue === null || cachedValue === void 0 ? void 0 : cachedValue.matchRuleParameterCacheKey) !== matchRuleParameterCacheKey || !cachedMappings || utils_typeof(cachedMappings) !== 'object') {
    if (cachedValue) (0,storage/* default */.Z)(EXPERIMENT_CACHE_KEY).clear();
    return {
      mappings: new Map(),
      cachedSpuCodes: new Set(),
      entries: {}
    };
  }
  var now = (0,dayjs/* default */.ZP)();
  var mappings = new Map();
  var cachedSpuCodes = new Set();
  var entries = {};
  var hasExpiredEntry = false;
  for (var _i = 0, _Object$entries = Object.entries(cachedMappings); _i < _Object$entries.length; _i++) {
    var _cachedEntry$expiresA;
    var _Object$entries$_i = utils_slicedToArray(_Object$entries[_i], 2),
      spuCode = _Object$entries$_i[0],
      cachedEntry = _Object$entries$_i[1];
    var normalizedSpuCode = toSpuCode(spuCode);
    var replacementSpuCode = toSpuCode(cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.replacementSpu);
    var hasReplacement = replacementSpuCode && normalizedSpuCode !== replacementSpuCode;
    var hasNoReplacement = (cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.replacementSpu) === '';
    var expiresAt = Number((_cachedEntry$expiresA = cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.expiresAt) !== null && _cachedEntry$expiresA !== void 0 ? _cachedEntry$expiresA : cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.timestamp);
    var hasLegacyTimestamp = (cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.expiresAt) === undefined && (cachedEntry === null || cachedEntry === void 0 ? void 0 : cachedEntry.timestamp) !== undefined;
    var valid = normalizedSpuCode && expiresAt && (hasReplacement || hasNoReplacement) && (0,dayjs/* default */.ZP)(expiresAt).isAfter(now);
    if (!valid) {
      hasExpiredEntry = true;
      continue;
    }
    if (hasLegacyTimestamp) hasExpiredEntry = true;
    cachedSpuCodes.add(normalizedSpuCode);
    if (hasReplacement) {
      mappings.set(normalizedSpuCode, replacementSpuCode);
    }
    entries[normalizedSpuCode] = {
      replacementSpu: hasReplacement ? replacementSpuCode : '',
      expiresAt: expiresAt
    };
  }
  if (hasExpiredEntry) {
    if (Object.keys(entries).length > 0) {
      (0,storage/* default */.Z)(EXPERIMENT_CACHE_KEY).set({
        matchRuleParameterCacheKey: matchRuleParameterCacheKey,
        spuMappings: entries
      });
    } else {
      (0,storage/* default */.Z)(EXPERIMENT_CACHE_KEY).clear();
    }
  }
  return {
    mappings: mappings,
    cachedSpuCodes: cachedSpuCodes,
    entries: entries
  };
};
var saveExperimentMappings = function saveExperimentMappings(mappings, matchRuleParameterCacheKey) {
  if (mappings.size === 0) return;
  var _readCachedExperiment = readCachedExperimentMappings(matchRuleParameterCacheKey),
    entries = _readCachedExperiment.entries;
  var _iterator2 = utils_createForOfIteratorHelper(mappings),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = utils_slicedToArray(_step2.value, 2),
        spuCode = _step2$value[0],
        cacheEntry = _step2$value[1];
      entries[spuCode] = {
        replacementSpu: (cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.replacementSpu) || '',
        expiresAt: Number(cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.expiresAt)
      };
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  (0,storage/* default */.Z)(EXPERIMENT_CACHE_KEY).set({
    matchRuleParameterCacheKey: matchRuleParameterCacheKey,
    spuMappings: entries
  });
};
var parseProperties = function parseProperties(element) {
  var configElement = element.querySelector(':scope > script.product-card-group__item__props');
  if (!(configElement !== null && configElement !== void 0 && configElement.textContent)) return undefined;
  try {
    return JSON.parse(configElement.textContent);
  } catch (_unused) {
    return undefined;
  }
};
var setLoading = function setLoading(element, loading) {
  element.classList.toggle('product-card-group__item--flow-exp-loading', loading);
  if (loading) {
    element.setAttribute('aria-busy', 'true');
  } else {
    element.removeAttribute('aria-busy');
  }
};
var finish = function finish(elements) {
  var _iterator3 = utils_createForOfIteratorHelper(elements),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var element = _step3.value;
      setLoading(element, false);
      element.dataset.flowExpProcessed = 'true';
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
};
var isProductRedirectExperiment = function isProductRedirectExperiment(item) {
  var mainParameter = toSpuCode(item === null || item === void 0 ? void 0 : item.mainParam);
  var groupContent = toSpuCode(item === null || item === void 0 ? void 0 : item.groupContent);
  return (item === null || item === void 0 ? void 0 : item.state) === 'ENABLED' && (item === null || item === void 0 ? void 0 : item.groupType) === 'TEST' && mainParameter && groupContent && mainParameter !== groupContent;
};
var groupByProperties = function groupByProperties(items) {
  var groupMap = new Map();
  var _iterator4 = utils_createForOfIteratorHelper(items),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var item = _step4.value;
      var properties = parseProperties(item.element);
      if (!properties) continue;
      var key = JSON.stringify(properties);
      var group = groupMap.get(key) || {
        properties: properties,
        items: []
      };
      group.items.push(item);
      groupMap.set(key, group);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return utils_toConsumableArray(groupMap.values());
};
var getProductHandleMapBySpuCode = /*#__PURE__*/function () {
  var _ref4 = utils_asyncToGenerator(/*#__PURE__*/utils_regenerator().m(function _callee(spuCodes) {
    var products;
    return utils_regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return getProductHandlesBySpuCode(spuCodes);
        case 1:
          products = _context.v;
          return _context.a(2, new Map(products.map(function (product) {
            return [toSpuCode(product === null || product === void 0 ? void 0 : product.id), product];
          }).filter(function (_ref5) {
            var _ref6 = utils_slicedToArray(_ref5, 2),
              spuCode = _ref6[0],
              product = _ref6[1];
            return spuCode && (product === null || product === void 0 ? void 0 : product.handle);
          })));
      }
    }, _callee);
  }));
  return function getProductHandleMapBySpuCode(_x) {
    return _ref4.apply(this, arguments);
  };
}();
var renderGroup = /*#__PURE__*/function () {
  var _ref8 = utils_asyncToGenerator(/*#__PURE__*/utils_regenerator().m(function _callee2(_ref7) {
    var items, properties, productMap, productByReplacementSpu, handles, renderedItems, itemBySpuCode, itemByHandle, _iterator5, _step5, _step5$value, replacementSpuCode, product, renderedItem, _iterator6, _step6, item, element, _replacementSpuCode, _renderedItem, replacement, _t, _t2;
    return utils_regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          items = _ref7.items, properties = _ref7.properties, productMap = _ref7.productMap;
          productByReplacementSpu = new Map(items.map(function (item) {
            return [item.replacementSpuCode, productMap.get(item.replacementSpuCode)];
          }).filter(function (_ref9) {
            var _ref0 = utils_slicedToArray(_ref9, 2),
              product = _ref0[1];
            return product === null || product === void 0 ? void 0 : product.handle;
          }));
          handles = utils_toConsumableArray(new Set(utils_toConsumableArray(productByReplacementSpu.values()).map(function (product) {
            return product.handle;
          })));
          if (!(handles.length === 0)) {
            _context2.n = 1;
            break;
          }
          finish(items.map(function (item) {
            return item.element;
          }));
          return _context2.a(2);
        case 1:
          _context2.p = 1;
          _context2.n = 2;
          return (0,get_product_card_group_item_list/* default */.Z)({
            handles: handles,
            returnType: 'node',
            parameters: properties
          });
        case 2:
          renderedItems = _context2.v;
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t = _context2.v;
          console.warn('product-card-group item rendering failed:', _t);
          finish(items.map(function (item) {
            return item.element;
          }));
          return _context2.a(2);
        case 4:
          itemBySpuCode = new Map(renderedItems.map(function (item) {
            var _item$dataset;
            return [toSpuCode(item === null || item === void 0 || (_item$dataset = item.dataset) === null || _item$dataset === void 0 ? void 0 : _item$dataset.productId), item];
          }).filter(function (_ref1) {
            var _ref10 = utils_slicedToArray(_ref1, 2),
              spuCode = _ref10[0],
              item = _ref10[1];
            return spuCode && item;
          })); // getProductCardGroupItemList 按传入 handle 顺序返回节点；以此建立兜底映射，
          // 避免回填 HTML 的 data-product-id 缺失或格式变化导致测试组命中后无法替换。
          itemByHandle = new Map(handles.map(function (handle, index) {
            return [handle, renderedItems[index]];
          }));
          _iterator5 = utils_createForOfIteratorHelper(productByReplacementSpu);
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              _step5$value = utils_slicedToArray(_step5.value, 2), replacementSpuCode = _step5$value[0], product = _step5$value[1];
              if (!itemBySpuCode.has(replacementSpuCode)) {
                renderedItem = itemByHandle.get(product.handle);
                if (renderedItem) itemBySpuCode.set(replacementSpuCode, renderedItem);
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          _iterator6 = utils_createForOfIteratorHelper(items);
          _context2.p = 5;
          _iterator6.s();
        case 6:
          if ((_step6 = _iterator6.n()).done) {
            _context2.n = 9;
            break;
          }
          item = _step6.value;
          element = item.element, _replacementSpuCode = item.replacementSpuCode;
          _renderedItem = itemBySpuCode.get(_replacementSpuCode);
          if (!(!_renderedItem || !element.isConnected)) {
            _context2.n = 7;
            break;
          }
          console.warn('product-card-group replacement node unavailable:', {
            replacementSpuCode: _replacementSpuCode,
            handles: handles,
            renderedProductIds: renderedItems.map(function (node) {
              var _node$dataset;
              return node === null || node === void 0 || (_node$dataset = node.dataset) === null || _node$dataset === void 0 ? void 0 : _node$dataset.productId;
            })
          });
          finish([element]);
          return _context2.a(3, 8);
        case 7:
          replacement = _renderedItem.cloneNode(true);
          replacement.dataset.index = element.dataset.index || replacement.dataset.index;
          replacement.dataset.flowExpProcessed = 'true';
          if (element.style.display) replacement.style.display = element.style.display;
          element.replaceWith(replacement);
          replacement.dispatchEvent(new CustomEvent('product-card-group-item:replaced', {
            bubbles: true
          }));
        case 8:
          _context2.n = 6;
          break;
        case 9:
          _context2.n = 11;
          break;
        case 10:
          _context2.p = 10;
          _t2 = _context2.v;
          _iterator6.e(_t2);
        case 11:
          _context2.p = 11;
          _iterator6.f();
          return _context2.f(11);
        case 12:
          return _context2.a(2);
      }
    }, _callee2, null, [[5, 10, 11, 12], [1, 3]]);
  }));
  return function renderGroup(_x2) {
    return _ref8.apply(this, arguments);
  };
}();
var replaceMatchedItems = /*#__PURE__*/function () {
  var _ref11 = utils_asyncToGenerator(/*#__PURE__*/utils_regenerator().m(function _callee3(matchedItems) {
    var replacementSpuCodes, productMap, _iterator7, _step7, group, _t3, _t4;
    return utils_regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          replacementSpuCodes = utils_toConsumableArray(new Set(matchedItems.map(function (item) {
            return item.replacementSpuCode;
          })));
          _context3.p = 1;
          _context3.n = 2;
          return getProductHandleMapBySpuCode(replacementSpuCodes);
        case 2:
          productMap = _context3.v;
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t3 = _context3.v;
          console.warn('product-card-group Storefront product lookup failed:', _t3);
          finish(matchedItems.map(function (item) {
            return item.element;
          }));
          return _context3.a(2);
        case 4:
          _iterator7 = utils_createForOfIteratorHelper(groupByProperties(matchedItems));
          _context3.p = 5;
          _iterator7.s();
        case 6:
          if ((_step7 = _iterator7.n()).done) {
            _context3.n = 8;
            break;
          }
          group = _step7.value;
          _context3.n = 7;
          return renderGroup(_objectSpread(_objectSpread({}, group), {}, {
            productMap: productMap
          }));
        case 7:
          _context3.n = 6;
          break;
        case 8:
          _context3.n = 10;
          break;
        case 9:
          _context3.p = 9;
          _t4 = _context3.v;
          _iterator7.e(_t4);
        case 10:
          _context3.p = 10;
          _iterator7.f();
          return _context3.f(10);
        case 11:
          return _context3.a(2);
      }
    }, _callee3, null, [[5, 9, 10, 11], [1, 3]]);
  }));
  return function replaceMatchedItems(_x3) {
    return _ref11.apply(this, arguments);
  };
}();
var processBatch = /*#__PURE__*/function () {
  var _ref12 = utils_asyncToGenerator(/*#__PURE__*/utils_regenerator().m(function _callee4(itemsBySpuCode) {
    var mainParameterList, matchRuleParameter, matchRuleParameterCacheKey, _readCachedExperiment2, experimentMap, cachedSpuCodes, missingMainParameterList, responseList, noReplacementExpirationTime, newExperimentMappings, _iterator8, _step8, item, mainParameter, replacementSpuCode, matchedItems, _iterator9, _step9, _step9$value, _mainParameter, elements, _replacementSpuCode2, _iterator0, _step0, element, _t5, _t6, _t7;
    return utils_regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          mainParameterList = utils_toConsumableArray(itemsBySpuCode.keys());
          matchRuleParameter = getMatchRuleParameters();
          matchRuleParameterCacheKey = getMatchRuleParameterCacheKey(matchRuleParameter);
          _readCachedExperiment2 = readCachedExperimentMappings(matchRuleParameterCacheKey), experimentMap = _readCachedExperiment2.mappings, cachedSpuCodes = _readCachedExperiment2.cachedSpuCodes;
          missingMainParameterList = mainParameterList.filter(function (spuCode) {
            return !cachedSpuCodes.has(spuCode);
          });
          if (!(missingMainParameterList.length > 0)) {
            _context4.n = 5;
            break;
          }
          responseList = [];
          _context4.p = 1;
          _context4.n = 2;
          return (0,ab_test/* batchMatchFlowExperiment */.e)(EXPERIMENT_TYPE, missingMainParameterList, {
            matchRuleParam: matchRuleParameter
          });
        case 2:
          responseList = _context4.v;
          _context4.n = 4;
          break;
        case 3:
          _context4.p = 3;
          _t5 = _context4.v;
          console.warn('product-card-group experiment match failed:', _t5);
          finish(utils_toConsumableArray(itemsBySpuCode.values()).flat());
          return _context4.a(2);
        case 4:
          noReplacementExpirationTime = getDefaultCacheExpirationTime();
          newExperimentMappings = new Map(missingMainParameterList.map(function (spuCode) {
            return [spuCode, {
              replacementSpu: '',
              expiresAt: noReplacementExpirationTime
            }];
          }));
          _iterator8 = utils_createForOfIteratorHelper(responseList.filter(function (item) {
            return isProductRedirectExperiment(item);
          }));
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              item = _step8.value;
              mainParameter = toSpuCode(item.mainParam);
              replacementSpuCode = toSpuCode(item.groupContent);
              experimentMap.set(mainParameter, replacementSpuCode);
              newExperimentMappings.set(mainParameter, {
                replacementSpu: replacementSpuCode,
                expiresAt: getExperimentCacheExpirationTime(item.expirationTime)
              });
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          saveExperimentMappings(newExperimentMappings, matchRuleParameterCacheKey);
        case 5:
          matchedItems = [];
          _iterator9 = utils_createForOfIteratorHelper(itemsBySpuCode);
          _context4.p = 6;
          _iterator9.s();
        case 7:
          if ((_step9 = _iterator9.n()).done) {
            _context4.n = 17;
            break;
          }
          _step9$value = utils_slicedToArray(_step9.value, 2), _mainParameter = _step9$value[0], elements = _step9$value[1];
          _replacementSpuCode2 = experimentMap.get(_mainParameter);
          if (_replacementSpuCode2) {
            _context4.n = 8;
            break;
          }
          finish(elements);
          return _context4.a(3, 16);
        case 8:
          _iterator0 = utils_createForOfIteratorHelper(elements);
          _context4.p = 9;
          _iterator0.s();
        case 10:
          if ((_step0 = _iterator0.n()).done) {
            _context4.n = 13;
            break;
          }
          element = _step0.value;
          if (element.isConnected) {
            _context4.n = 11;
            break;
          }
          return _context4.a(3, 12);
        case 11:
          setLoading(element, true);
          matchedItems.push({
            element: element,
            replacementSpuCode: _replacementSpuCode2
          });
        case 12:
          _context4.n = 10;
          break;
        case 13:
          _context4.n = 15;
          break;
        case 14:
          _context4.p = 14;
          _t6 = _context4.v;
          _iterator0.e(_t6);
        case 15:
          _context4.p = 15;
          _iterator0.f();
          return _context4.f(15);
        case 16:
          _context4.n = 7;
          break;
        case 17:
          _context4.n = 19;
          break;
        case 18:
          _context4.p = 18;
          _t7 = _context4.v;
          _iterator9.e(_t7);
        case 19:
          _context4.p = 19;
          _iterator9.f();
          return _context4.f(19);
        case 20:
          if (!(matchedItems.length > 0)) {
            _context4.n = 21;
            break;
          }
          _context4.n = 21;
          return replaceMatchedItems(matchedItems);
        case 21:
          return _context4.a(2);
      }
    }, _callee4, null, [[9, 14, 15, 16], [6, 18, 19, 20], [1, 3]]);
  }));
  return function processBatch(_x4) {
    return _ref12.apply(this, arguments);
  };
}();
var flushExperimentQueue = /*#__PURE__*/function () {
  var _ref13 = utils_asyncToGenerator(/*#__PURE__*/utils_regenerator().m(function _callee5() {
    var batch, _iterator1, _step1, _step1$value, spuCode, items, _t8;
    return utils_regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          if (!isFlushing) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2);
        case 1:
          isFlushing = true;
          _context5.p = 2;
        case 3:
          if (!(queuedItems.size > 0)) {
            _context5.n = 12;
            break;
          }
          batch = new Map();
          _iterator1 = utils_createForOfIteratorHelper(queuedItems);
          _context5.p = 4;
          _iterator1.s();
        case 5:
          if ((_step1 = _iterator1.n()).done) {
            _context5.n = 7;
            break;
          }
          _step1$value = utils_slicedToArray(_step1.value, 2), spuCode = _step1$value[0], items = _step1$value[1];
          queuedItems.delete(spuCode);
          batch.set(spuCode, items);
          if (!(batch.size === BATCH_SIZE)) {
            _context5.n = 6;
            break;
          }
          return _context5.a(3, 7);
        case 6:
          _context5.n = 5;
          break;
        case 7:
          _context5.n = 9;
          break;
        case 8:
          _context5.p = 8;
          _t8 = _context5.v;
          _iterator1.e(_t8);
        case 9:
          _context5.p = 9;
          _iterator1.f();
          return _context5.f(9);
        case 10:
          _context5.n = 11;
          return processBatch(batch);
        case 11:
          _context5.n = 3;
          break;
        case 12:
          _context5.p = 12;
          isFlushing = false;
          if (queuedItems.size > 0) scheduleExperimentFlush();
          return _context5.f(12);
        case 13:
          return _context5.a(2);
      }
    }, _callee5, null, [[4, 8, 9, 10], [2,, 12, 13]]);
  }));
  return function flushExperimentQueue() {
    return _ref13.apply(this, arguments);
  };
}();
var scheduleExperimentFlush = (0,lodash/* debounce */.Ds)(function () {
  flushExperimentQueue().catch(function (error) {
    console.warn('product-card-group experiment queue failed:', error);
  });
}, 80);

/**
 * 收集当前页面已渲染的商品卡片；以 SPU 去重后调用 PAGE_REDIRECT 批量实验接口。
 * 每次请求最多携带 50 个 mainParam；命中 TEST 时复用既有 Liquid item 渲染接口替换卡片。
 *
 * @param {HTMLElement} element
 */
var registerProductCardGroupItemExperiment = function registerProductCardGroupItemExperiment(element) {
  if (!(element !== null && element !== void 0 && element.isConnected) || element.dataset.flowExpProcessed === 'true' || element.dataset.flowExpQueued === 'true') {
    return;
  }
  var spuCode = toSpuCode(element.dataset.productId);
  if (!spuCode || !parseProperties(element)) return;
  element.dataset.flowExpQueued = 'true';
  var elements = queuedItems.get(spuCode) || [];
  elements.push(element);
  queuedItems.set(spuCode, elements);
  scheduleExperimentFlush();
};

/**
 * 批量处理待初始化的组件
 * 使用单个 requestIdleCallback 处理多个组件，避免多个 callback 排队
 */
var pendingComponents = new Set();
var idleCallbackId;

/**
 * 批量处理待初始化的组件
 * 使用 timeRemaining() 确保在空闲时间内完成
 */
function processPendingComponents(deadline) {
  var startTime = performance.now();
  var maxExecutionTime = 8; // 单批最多 8ms，避免形成长任务

  while (pendingComponents.size > 0 && (deadline.timeRemaining() > 0 || deadline.didTimeout)) {
    // 检查是否超过最大执行时间
    if (performance.now() - startTime > maxExecutionTime) {
      // 如果超过时间，重新调度剩余组件
      scheduleIdleCallback();
      break;
    }

    // 获取并处理第一个待初始化的组件
    var component = pendingComponents.values().next().value;
    if (component) {
      pendingComponents.delete(component);
      try {
        var _component$componentD;
        (_component$componentD = component.componentDidMount) === null || _component$componentD === void 0 || _component$componentD.call(component);
      } catch (error) {
        console.error('componentDidMount error:', error);
      }
    }
  }

  // 如果还有待处理的组件，继续调度
  if (pendingComponents.size > 0) {
    scheduleIdleCallback();
  } else {
    idleCallbackId = undefined; // 重置，允许下次调度
  }
}

/**
 * 调度 idle callback
 */
function scheduleIdleCallback() {
  if (idleCallbackId !== undefined) {
    return; // 已经调度过了
  }
  (0,rIC/* rIC */.$)(processPendingComponents, {
    timeout: 2000
  });
  idleCallbackId = true; // 标记已调度（rIC 可能不返回 ID）
}
var _mounted = /*#__PURE__*/new WeakMap();
var LightweightCustomElement = /*#__PURE__*/function (_HTMLElement) {
  function LightweightCustomElement() {
    var _this;
    _classCallCheck(this, LightweightCustomElement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LightweightCustomElement, [].concat(args));
    _classPrivateFieldInitSpec(_this, _mounted, false);
    return _this;
  }
  _inherits(LightweightCustomElement, _HTMLElement);
  return _createClass(LightweightCustomElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (_classPrivateFieldGet(_mounted, this)) return;
      _classPrivateFieldSet(_mounted, this, true);

      // 将组件添加到待处理队列，批量处理
      pendingComponents.add(this);
      scheduleIdleCallback();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$componentWillUn;
      (_this$componentWillUn = this.componentWillUnmount) === null || _this$componentWillUn === void 0 || _this$componentWillUn.call(this);
    }
  }, {
    key: "isMounted",
    value: function isMounted() {
      return _classPrivateFieldGet(_mounted, this);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
;// CONCATENATED MODULE: ./snippets/product-card-group/item/src/custom-elements.js
function custom_elements_typeof(o) { "@babel/helpers - typeof"; return custom_elements_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, custom_elements_typeof(o); }
function custom_elements_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function custom_elements_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, custom_elements_toPropertyKey(o.key), o); } }
function custom_elements_createClass(e, r, t) { return r && custom_elements_defineProperties(e.prototype, r), t && custom_elements_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function custom_elements_toPropertyKey(t) { var i = custom_elements_toPrimitive(t, "string"); return "symbol" == custom_elements_typeof(i) ? i : i + ""; }
function custom_elements_toPrimitive(t, r) { if ("object" != custom_elements_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != custom_elements_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function custom_elements_callSuper(t, o, e) { return o = custom_elements_getPrototypeOf(o), custom_elements_possibleConstructorReturn(t, custom_elements_isNativeReflectConstruct() ? Reflect.construct(o, e || [], custom_elements_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function custom_elements_possibleConstructorReturn(t, e) { if (e && ("object" == custom_elements_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return custom_elements_assertThisInitialized(t); }
function custom_elements_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function custom_elements_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (custom_elements_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function custom_elements_getPrototypeOf(t) { return custom_elements_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, custom_elements_getPrototypeOf(t); }
function custom_elements_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && custom_elements_setPrototypeOf(t, e); }
function custom_elements_setPrototypeOf(t, e) { return custom_elements_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, custom_elements_setPrototypeOf(t, e); }
function _classPrivateMethodInitSpec(e, a) { custom_elements_checkPrivateRedeclaration(e, a), a.add(e); }
function custom_elements_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function custom_elements_assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function custom_elements_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = custom_elements_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function custom_elements_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return custom_elements_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? custom_elements_arrayLikeToArray(r, a) : void 0; } }
function custom_elements_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



































var reviewObserverTargets = new WeakMap();
var REVIEW_WRAPPER = Symbol('reviewWrapper');
var reviewObserver;
var getReviewObserver = function getReviewObserver() {
  if (reviewObserver) return reviewObserver;
  reviewObserver = new IntersectionObserver(function (entries) {
    var _iterator = custom_elements_createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        if (!entry.isIntersecting) continue;
        var callback = reviewObserverTargets.get(entry.target);
        reviewObserver.unobserve(entry.target);
        reviewObserverTargets.delete(entry.target);
        try {
          callback === null || callback === void 0 || callback();
        } catch (error) {
          console.error('review observer callback error:', error);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    rootMargin: '60px'
  });
  return reviewObserver;
};
var observeReviewElement = function observeReviewElement(element, callback) {
  if (!element) return;
  reviewObserverTargets.set(element, callback);
  getReviewObserver().observe(element);
};
var unobserveReviewElement = function unobserveReviewElement(element) {
  var _reviewObserver;
  if (!element) return;
  (_reviewObserver = reviewObserver) === null || _reviewObserver === void 0 || _reviewObserver.unobserve(element);
  reviewObserverTargets.delete(element);
};
var bindEvents = function bindEvents() {
  if (!misc/* isMobile */.tq) {
    (0,event_handler.on)('mouseover', '.product-card-group__item__carousel', (0,lodash/* debounce */.Ds)(function (event) {
      var delegateTarget = event.delegateTarget;
      var entered = delegateTarget.dataset.entered;
      if (entered === 'true' || !delegateTarget.classList.contains('product-card-group__item__carousel')) {
        return;
      }
      delegateTarget.dataset.entered = 'true';
      var mediaGallery = delegateTarget.closest('mec-carousel');
      if (!mediaGallery) {
        return;
      }
      var currentImageIndex = mediaGallery.getAttribute('active-index');
      var maxCarouselIndex = mediaGallery.maxCarouselIndex;
      var index = Number(currentImageIndex) === maxCarouselIndex ? 0 : Number(currentImageIndex) + 1;
      mediaGallery.setAttribute('active-index', index);
    }, 0));
    (0,event_handler.on)('mouseout', '.product-card-group__item__carousel', (0,lodash/* debounce */.Ds)(function (event) {
      var delegateTarget = event.delegateTarget;
      var entered = delegateTarget.dataset.entered;
      if (entered !== 'true' || !delegateTarget.classList.contains('product-card-group__item__carousel')) {
        return;
      }
      delegateTarget.dataset.entered = 'false';
      var mediaGallery = delegateTarget.closest('mec-carousel');
      if (!mediaGallery) {
        return;
      }
      var currentImageIndex = mediaGallery.getAttribute('active-index');
      var maxCarouselIndex = mediaGallery.maxCarouselIndex;
      var index = Number(currentImageIndex) === 0 ? maxCarouselIndex : currentImageIndex - 1;
      mediaGallery.setAttribute('active-index', index);
    }, 0));
  }
  (0,event_handler.on)('click', '.product-card-group__handler', function (event) {
    event.preventDefault();
    event.stopPropagation();
    var productUrl = event.currentTarget.dataset.href;
    (0,quick_add_to_cart/* quickAddToCart */.G)({
      productUrl: productUrl,
      event: event
    });
  });

  // on(
  //   'click',
  //   '.product-card-group__item__swym-button',
  //   async (event) => {
  //     const ele = event.currentTarget
  //     const { variantId, productId, productUrl } = ele.dataset
  //     const product = {
  //       epi: Number(variantId),
  //       empi: Number(productId),
  //       du: productUrl,
  //     }

  //     if (ele.classList.contains('swym-added')) {
  //       const result = await removeSwymApi(product)
  //       if (result) ele.classList.remove('disabled', 'swym-added')
  //     } else {
  //       const result = await addSwymApi(product)
  //       if (result) ele.classList.add('disabled', 'swym-added')
  //     }
  //   },
  //   {
  //     capture: true,
  //   },
  // )
};
bindEvents();
var _ProductCardGroupItem_brand = /*#__PURE__*/new WeakSet();
var ProductCardGroupItem = /*#__PURE__*/function (_LightweightCustomEle) {
  function ProductCardGroupItem() {
    var _this;
    custom_elements_classCallCheck(this, ProductCardGroupItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = custom_elements_callSuper(this, ProductCardGroupItem, [].concat(args));
    _classPrivateMethodInitSpec(_this, _ProductCardGroupItem_brand);
    return _this;
  }
  custom_elements_inherits(ProductCardGroupItem, _LightweightCustomEle);
  return custom_elements_createClass(ProductCardGroupItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      custom_elements_assertClassBrand(_ProductCardGroupItem_brand, this, _setup).call(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      unobserveReviewElement(this[REVIEW_WRAPPER]);
      this[REVIEW_WRAPPER] = undefined;
    }
  }]);
}(LightweightCustomElement);
function _setup() {
  var _this2 = this;
  registerProductCardGroupItemExperiment(this);
  custom_elements_assertClassBrand(_ProductCardGroupItem_brand, this, _renderProductTag).call(this);
  custom_elements_assertClassBrand(_ProductCardGroupItem_brand, this, _resetReviewsText).call(this);
  (0,rIC/* rIC */.$)(function () {
    if (_this2.dataset.csr === 'true') {
      productImpression();
      showSwymList();
    }
  });
}
function _productTagTemplate(_ref) {
  var content = _ref.content,
    priority = _ref.priority;
  var fragment = document.createElement('span');
  fragment.classList.add('product-card-group__item__tag');
  fragment.classList.add("product-card-group__item__tag--".concat(priority));
  fragment.innerHTML = content;
  return fragment;
}
function _initReviews(reviewWrapperElement) {
  var reviewElement = this.querySelector('.jdgm-prev-badge');
  var reviewTextElement = reviewElement === null || reviewElement === void 0 ? void 0 : reviewElement.querySelector('.jdgm-prev-badge__text');
  if (reviewTextElement && typeof reviewTextElement.textContent === 'string') {
    // 提取所有数字
    var numbersOnly = reviewTextElement.textContent.replaceAll(/\s+/g, '').replaceAll(/\D+/g, '');
    reviewTextElement.textContent = numbersOnly;
  }
  var numberOfReviews = Number(reviewElement.dataset.numberOfReviews);
  if (!numberOfReviews) {
    reviewWrapperElement.innerHTML = 'Latest Drop!';
  }
  reviewWrapperElement.classList.add('product-card-group__item__content__reviews--show');
}
function _resetReviewsText() {
  var _this3 = this;
  var reviewWrapperElement = this.querySelector('.product-card-group__item__content__reviews');
  if (!reviewWrapperElement) {
    return;
  }

  // 动态插入的新商品卡会在 connectedCallback 时注册到同一个共享 Observer。
  this[REVIEW_WRAPPER] = reviewWrapperElement;
  observeReviewElement(reviewWrapperElement, function () {
    custom_elements_assertClassBrand(_ProductCardGroupItem_brand, _this3, _initReviews).call(_this3, reviewWrapperElement);
  });
}
function _renderProductTag() {
  var priceElement = this.querySelector('.original-main-product__price-wrapper');
  var logoWrapperElement = this.querySelector('.product-card-group__item__logo');
  if (!priceElement || !logoWrapperElement) {
    return;
  }
  var productTags = [];
  try {
    productTags = JSON.parse(this.dataset.productTags) || [];
  } catch (_unused) {}
  var _priceElement$dataset = priceElement.dataset,
    dealPrice = _priceElement$dataset.dealPrice,
    price = _priceElement$dataset.price,
    priceType = _priceElement$dataset.priceType;
  var productTagHtml = (0,create/* default */.Z)({
    tags: productTags
  }, price, [1, 3, 4].includes(Number(priceType)) ? dealPrice : undefined);
  if (productTagHtml) {
    var productTagWrapper = document.createElement('div');
    productTagWrapper.innerHTML = productTagHtml;
    var productLabelElement = productTagWrapper.querySelector('.snippet-product-label');
    var priority = ['high', 'medium', 'low'].find(function (item) {
      return productLabelElement === null || productLabelElement === void 0 ? void 0 : productLabelElement.classList.contains("snippet-product-label--".concat(item));
    });
    if (!productLabelElement || !priority) {
      return;
    }
    logoWrapperElement.append(custom_elements_assertClassBrand(_ProductCardGroupItem_brand, this, _productTagTemplate).call(this, {
      content: productLabelElement.innerHTML,
      priority: priority
    }));
  }
}
/* harmony default export */ var custom_elements = (ProductCardGroupItem);
;// CONCATENATED MODULE: ./snippets/product-card-group/item/index.js




var item_init = function init() {
  event_tracking();
  (0,rIC/* rIC */.$)(function () {
    productImpression();
    showSwymList();
  });
  if (customElements.get('product-card-group-item')) {
    return;
  }
  customElements.define('product-card-group-item', custom_elements);
};
item_init();
// EXTERNAL MODULE: ../node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(48914);
// EXTERNAL MODULE: ../node_modules/number-precision/build/index.es.js
var index_es = __webpack_require__(17887);
;// CONCATENATED MODULE: ./snippets/product-progress-bar/index.js
function product_progress_bar_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = product_progress_bar_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function product_progress_bar_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return product_progress_bar_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? product_progress_bar_arrayLikeToArray(r, a) : void 0; } }
function product_progress_bar_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }














var setProgressBar = function setProgressBar(progressBarNode, currentTime, beginTime, endTime) {
  if (progressBarNode.classList.contains('snippets-product-progress-bar__sold-out')) {
    progressBarNode.innerHTML = 'Sold Out';
    return;
  }
  var _progressBarNode$data = progressBarNode.dataset,
    barType = _progressBarNode$data.barType,
    productId = _progressBarNode$data.productId;
  if (!productId || !barType) return;
  var basePercent, maxPercent, growthPercent;
  switch (barType) {
    case 's':
      {
        basePercent = productId % 6 + 80;
        maxPercent = 100;
        break;
      }
    case 'a':
      {
        basePercent = productId % 11 + 50;
        maxPercent = 80;
        break;
      }
    case 'b':
      {
        basePercent = productId % 21 + 10;
        maxPercent = 50;
        break;
      }
  }
  var remainingPercent = maxPercent - basePercent;
  var reflashTime = '24';
  if (reflashTime === '1') {
    // 上午12个小时，增长比例为30%*剩余区间，匀速增长，下午12小时，增长比例为70%*剩余区间，匀速增长
    var currentHour = currentTime.getHours();
    growthPercent = currentHour > 12 ? index_es/* default.plus */.ZP.plus((remainingPercent * 0.7 * ((currentHour - 12) / 12)).toFixed(2), (remainingPercent * 0.3).toFixed(2)) : (remainingPercent * 0.3 * (currentHour / 12)).toFixed(2);
  } else {
    var during = index_es/* default.minus */.ZP.minus(endTime.getTime(), beginTime.getTime());
    var passtime = index_es/* default.minus */.ZP.minus(currentTime.getTime(), beginTime.getTime());
    growthPercent = (remainingPercent * (passtime / during)).toFixed(2);
  }
  var totalPercent = index_es/* default.plus */.ZP.plus(basePercent, growthPercent).toFixed(2);
  var soldText = barType === 's' ? 'Almost Sold Out' : "".concat(totalPercent, "% Sold");
  var highlight = progressBarNode.querySelector('.snippets-product-progress-bar__highlight');
  var text = highlight.querySelector('.snippets-product-progress-bar__text');
  highlight.style.width = "".concat(totalPercent, "%");
  text.innerHTML = soldText;
  progressBarNode.style.display = 'block';
  delete progressBarNode.dataset.barType;
  delete progressBarNode.dataset.productId;
};
var removeProgressBar = function removeProgressBar(progressBarNodes) {
  var _iterator = product_progress_bar_createForOfIteratorHelper(progressBarNodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      item.remove();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var handleProgressBars = function handleProgressBars() {
  try {
    var progressBarNodes = document.querySelectorAll('.snippets-product-progress-bar');
    if (progressBarNodes.length === 0) return;
    var beginTimeSetting = '';
    var endTimeSetting = '';
    if (!beginTimeSetting || !endTimeSetting) {
      removeProgressBar(progressBarNodes);
      return;
    }
    var currentTime = new Date();
    var beginTime = new Date(beginTimeSetting);
    var endTime = new Date(endTimeSetting);
    if (currentTime < beginTime || currentTime > endTime) {
      removeProgressBar(progressBarNodes);
      return;
    }
    var _iterator2 = product_progress_bar_createForOfIteratorHelper(progressBarNodes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        setProgressBar(item, currentTime, beginTime, endTime);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } catch (error) {
    console.log('handle progress bar error:', error);
  }
};
document.addEventListener('DOMContentLoaded', function () {
  handleProgressBars();
});

// EXTERNAL MODULE: ./ui/index.js + 8 modules
var ui = __webpack_require__(75174);
// EXTERNAL MODULE: ./sections/original-main-product/index.js + 6 modules
var original_main_product = __webpack_require__(99659);
// EXTERNAL MODULE: ./definitions/index.js
var definitions = __webpack_require__(64155);
;// CONCATENATED MODULE: ./snippets/common/index.js



















function common_typeof(o) { "@babel/helpers - typeof"; return common_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, common_typeof(o); }
var _window$MISCELLANY_PR;
function common_toConsumableArray(r) { return common_arrayWithoutHoles(r) || common_iterableToArray(r) || common_unsupportedIterableToArray(r) || common_nonIterableSpread(); }
function common_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function common_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return common_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? common_arrayLikeToArray(r, a) : void 0; } }
function common_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function common_arrayWithoutHoles(r) { if (Array.isArray(r)) return common_arrayLikeToArray(r); }
function common_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function common_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function common_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? common_ownKeys(Object(t), !0).forEach(function (r) { common_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : common_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function common_defineProperty(e, r, t) { return (r = common_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function common_toPropertyKey(t) { var i = common_toPrimitive(t, "string"); return "symbol" == common_typeof(i) ? i : i + ""; }
function common_toPrimitive(t, r) { if ("object" != common_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != common_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















// 商品卡局部刷新（集合页筛选/排序/翻页、搜索页、推荐位等）后重新初始化
var updateProductList = function updateProductList() {
  handleProgressBars();
  productImpression();
};
window[definitions/* MISCELLANY_PREFIX */.x7] = Object.assign({}, (_window$MISCELLANY_PR = window[definitions/* MISCELLANY_PREFIX */.x7]) !== null && _window$MISCELLANY_PR !== void 0 ? _window$MISCELLANY_PR : {}, common_objectSpread(common_objectSpread(common_objectSpread({}, ui), original_main_product), {}, {
  updateProductList: updateProductList
}));

// 商品卡局部刷新（集合页筛选/排序/翻页、搜索页等）后重新初始化
var PRODUCT_CARD_SELECTOR = '.product-card-group__item, product-card-group-item';
var observeProductCardInsert = function observeProductCardInsert() {
  var timer = null;
  var observer = new MutationObserver(function (mutations) {
    var hasProductCard = mutations.some(function (mutation) {
      return common_toConsumableArray(mutation.addedNodes).some(function (node) {
        var _node$matches, _node$querySelector;
        return node.nodeType === 1 && (((_node$matches = node.matches) === null || _node$matches === void 0 ? void 0 : _node$matches.call(node, PRODUCT_CARD_SELECTOR)) || ((_node$querySelector = node.querySelector) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.call(node, PRODUCT_CARD_SELECTOR)));
      });
    });
    if (!hasProductCard) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      return updateProductList();
    }, 150);
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
};
observeProductCardInsert();

/***/ }),

/***/ 40429:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,80,555,736,114,836], function() { return __webpack_exec__(84560); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);